'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const gaIE = {
    el: {
        colorpicker: {
            confirm: 'Ceart go leor',
            clear: 'Glan'
        },
        datepicker: {
            now: 'Anois',
            today: 'Inniu',
            cancel: 'Cealaigh',
            clear: 'Glan',
            confirm: 'Ceart go leor',
            selectDate: 'Roghnaigh dáta',
            selectTime: 'Roghnaigh am',
            startDate: 'Dáta tosaigh',
            startTime: 'Am tosaigh',
            endDate: 'Dáta deiridh',
            endTime: 'Am deiridh',
            prevYear: 'An bhliain roimhe sin',
            nextYear: 'An bhliain seo chugainn',
            prevMonth: 'Mí roimhe seo',
            nextMonth: 'An mhí seo chugainn',
            year: '',
            month1: 'Eanáir',
            month2: 'Feabhra',
            month3: 'Márta',
            month4: 'Aibreán',
            month5: 'Bealtaine',
            month6: 'Meitheamh',
            month7: 'Iúil',
            month8: 'Lúnasa',
            month9: 'Meán Fómhair',
            month10: 'Deireadh Fómhair',
            month11: 'Samhain',
            month12: 'Nollaig',
            week: 'seachtain',
            weeks: {
                sun: 'Dom',
                mon: 'Lua',
                tue: 'Mái',
                wed: 'Céa',
                thu: 'Déa',
                fri: 'hAo',
                sat: 'Sat'
            },
            months: {
                jan: 'Ean',
                feb: 'Fea',
                mar: 'Már',
                apr: 'Aib',
                may: 'Bea',
                jun: 'Mei',
                jul: 'Iúi',
                aug: 'Lún',
                sep: 'Meá',
                oct: 'Dei',
                nov: 'Sam',
                dec: 'Nol'
            }
        },
        select: {
            loading: 'Ag luchtú',
            noMatch: 'Gan aon sonraí meaitseála',
            noData: 'Gan aon sonraí',
            placeholder: 'Roghnaigh'
        },
        cascader: {
            noMatch: 'Gan aon sonraí meaitseála',
            loading: 'Ag luchtú',
            placeholder: 'Roghnaigh',
            noData: 'Gan aon sonraí'
        },
        pagination: {
            goto: 'Téigh',
            pagesize: '/leathanach',
            total: 'Iomlán {total}',
            pageClassifier: ''
        },
        messagebox: {
            title: 'Teachtaireacht',
            confirm: 'Ceart go leor',
            cancel: 'Cealaigh',
            error: 'Ní cheadaítear ionchur'
        },
        upload: {
            deleteTip: 'brúigh scriosadh chun é a bhaint',
            delete: 'Scrios',
            preview: 'Réamhamharc',
            continue: 'Leanúint ar aghaidh'
        },
        table: {
            emptyText: 'Gan sonraí',
            confirmFilter: 'Deimhnigh',
            resetFilter: 'Athshocraigh',
            clearFilter: 'Gach',
            sumText: 'Suim'
        },
        tree: {
            emptyText: 'Gan sonraí'
        },
        transfer: {
            noMatch: 'Gan aon sonraí meaitseála',
            noData: 'Gan aon sonraí',
            titles: ['Liosta 1', 'Liosta 2'],
            filterPlaceholder: 'Iontráil eochairfhocal',
            noCheckedFormat: '{total} míreanna',
            hasCheckedFormat: '{checked}/{total} seiceáilte'
        },
        image: {
            error: 'FAILED'
        },
        pageHeader: {
            title: 'Ar ais'
        },
        popconfirm: {
            confirmButtonText: 'Sea',
            cancelButtonText: 'Níl'
        }
    }
};

exports["default"] = gaIE;